export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '3e6bbf38-fe59-485e-96fb-a69009454b32',
      authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
      redirectUri: 'https://euwftaxtc2wap01.azurewebsites.net',
    },
  },
  graphConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  apiConfig: {
    baseUrl: 'https://euwftaxtc2wap02.azurewebsites.net/api',
    scopes: ['api://3e6bbf38-fe59-485e-96fb-a69009454b32/.default'],
  },
  fileUpload: {
    maxFileSize: 5 * 1024 * 1024,
  },
};
